import React, { PureComponent } from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'
import Icon from 'aria-viewer/tour/components/icon'
import { MAIN_MAP_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

class MapDefault extends PureComponent {
    render() {
        const { onClick, style } = this.props

        return (
            <Button
                id="mapMin"
                onClick={onClick}
                style={Object.assign({}, style, { cursor: 'pointer' })}
                tabIndex={MAIN_MAP_INDEX}
            >
                <Icon
                    icon="map"
                    style={{
                        ':hover': {
                            transform: 'scale(1.1)',
                        },
                    }}
                />
            </Button>
        )
    }
}

export default MapDefault
